import {
  Card,
  CardContent,
  Box,
  Grid,
  Typography,
  Button,
  Chip,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import OrderTable from "./OrderTable";

const OrderCard = ({
  order,
  handleConfirmcheckedLines,
  orderIndex,
  handleQuantityChange,
  handleLineCheckboxChange,
  handleDeltaCheckboxChange,
  fetchSerialNumbers,
  serialNumbers,
  updateOrderData,
  onToggleReviewed,
}) => {
  return (
    <Box key={orderIndex} mb={2}>
      <Card>
        <CardContent sx={{ p: 0 }}>
          <Box sx={{ bgcolor: order.reviewed ? "#fff8e1" : "#ebf7ff", p: 2 }}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                <Typography variant="h7" fontWeight="normal">
                  הזמנה:{" "}
                  <span style={{ fontWeight: "bold" }}>{order.ordname}</span>
                  &nbsp;&nbsp;|&nbsp;&nbsp; שם לקוח:&nbsp;
                  <span style={{ fontWeight: "bold" }}>{order.custdes}</span>
                  &nbsp;&nbsp;|&nbsp;&nbsp; תאריך אספקה:&nbsp;
                  <span style={{ fontWeight: "bold" }}>
                    {order.neo_duedate}
                  </span>
                  &nbsp;&nbsp;|&nbsp;&nbsp; סטטוס הזמנה:&nbsp;
                  <span style={{ fontWeight: "bold" }}>
                    {order.ordstatusdes}
                  </span>
                  &nbsp;&nbsp;|&nbsp;&nbsp; לטיפול:&nbsp;
                  <span style={{ fontWeight: "bold" }}>
                    {order.neo_ownerlogin}
                  </span>
                  &nbsp;&nbsp;|&nbsp;&nbsp; לקוח מקבל:&nbsp;
                  <span style={{ fontWeight: "bold" }}>
                    {order.endcustname && order.endcustdes
                      ? `${order.endcustname} - ${order.endcustdes}`
                      : ""}
                  </span>
                </Typography>
                {order.reviewed && (
                  <Chip label="ממתין" size="small" color="warning" />
                )}
              </Grid>

              <Grid item sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant="outlined"
                  color={order.reviewed ? "warning" : "inherit"}
                  startIcon={order.reviewed ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  onClick={() => onToggleReviewed(order)}
                  sx={{
                    borderColor: order.reviewed ? undefined : "#bbb",
                    color: order.reviewed ? undefined : "#555",
                    "&:hover": {
                      backgroundColor: order.reviewed
                        ? "rgba(237,108,2,0.04)"
                        : "rgba(0,0,0,0.04)",
                    },
                  }}
                >
                  {order.reviewed ? "בטל המתנה" : "סמן כממתין"}
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<CheckCircleIcon />}
                  onClick={() => handleConfirmcheckedLines(order)}
                  sx={{
                    "&:hover": {
                      backgroundColor: "rgba(0, 84, 165, 0.04)",
                      borderColor: "#0054A5",
                    },
                  }}
                >
                  אשר שורות הזמנה
                </Button>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ p: 2 }}>
            <Grid container spacing={0}>
              <Grid item xs={2.8}>
                <Typography variant="body1">
                  מספר לקוח: {order.custname}
                </Typography>
                <Typography variant="body1">
                  מספר טלפון: {order.phone}
                </Typography>
              </Grid>
              <Grid item xs={2.8}>
                <Typography variant="body1">
                  סניף: {order.branchname}
                </Typography>
                <Typography variant="body1">
                  תת חברה: {order.companyname}
                </Typography>
              </Grid>
              <Grid item xs={2.8}>
                <Typography variant="body1">
                  תאריך הזמנה {order.curdate}
                </Typography>
                <Typography variant="body1">
                  סוג הזמנה: {order.typeDes} - {order.typeCode}
                </Typography>
              </Grid>
              <Grid item xs={3.5}>
                <Typography variant="body1">
                  לקוח מרכז:{" "}
                  {order.mcustname && order.mcustdes
                    ? `${order.mcustname} - ${order.mcustdes}`
                    : ""}
                </Typography>
                <Typography variant="body1">
                  לקוח מקבל:{" "}
                  {order.endcustname && order.endcustdes
                    ? `${order.endcustname} - ${order.endcustdes}`
                    : ""}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          {/* Integrate OrderTable */}
          <OrderTable
            order={order}
            orderIndex={orderIndex}
            handleQuantityChange={handleQuantityChange}
            handleLineCheckboxChange={handleLineCheckboxChange}
            handleDeltaCheckboxChange={handleDeltaCheckboxChange}
            fetchSerialNumbers={fetchSerialNumbers}
            serialNumbers={serialNumbers}
            updateOrderData={updateOrderData}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default OrderCard;
